import Progress from 'easy-circular-progress';
import { Inject } from 'vue-di-container';
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import LoaderService from '../../Services/LoaderService';
import { Toaster } from '../../Services/toast';
import ValidationService from '../../Services/ValidationService';
import UserModel from '../../shared/userService/Model/UserModel';
import UserRoleService from '../../shared/userService/UserRoleService';
import UserService from '../../shared/userService/UserService';
import { ReportModel } from '../Report/ReportModel';
import ReportService from '../Report/ReportService';
import WithRender from './MessageTemplateDashboard.html';
import { MessageDashboardBoxesModel } from './MessageDashboardBoxesModel';
import MessageTemplateRequestDashboardService from './MessageTemplateRequestDashboardService';
import { FilterModel } from './FilterModel';
import { MessageTemplateRequestModel } from './MessageTemplateRequestModel';
import { RejectionReasonModel } from '../RejectionReason/RejectionReasonModel';
import { DropdownModel } from '../Provider/ProviderModel';


@WithRender
@Component({
    components: {
        Progress,
    },
    diProvide: [
        MessageTemplateRequestDashboardService,
        UserService,
        ReportService,
        UserRoleService,
    ],
})
export default class MessageTemplateDashboard extends Vue {
    @Inject(UserService) public userService!: UserService;
    @Inject(MessageTemplateRequestDashboardService) public connectingRequestDashboardService!: MessageTemplateRequestDashboardService;
    @Inject(LoaderService) public loaderService!: LoaderService;
    @Inject(ValidationService) public validationService!: ValidationService;
    @Inject(ReportService) public reportService!: ReportService;
    @Inject(UserRoleService) public userRoleService!: UserRoleService;
    @Prop({ type: Boolean, default: false })
    public providerLocked: boolean = false;
    public providerExpired: boolean = false;
    public layoutSup: boolean | any;
    requestStatusBox: string[] = ['0'];
    public isFromFilterBox: boolean = false;
    public senderStatus: string = '';
    public Deleteids: string[] = [];
    public deleteDialog: boolean = false;
    public approveids: string[] = [];
    public approveDialog: boolean = false;
    public resendids: string[] = [];
    public resendDialog: boolean = false;
    public resendComment: string = '';
    public approveComment: string = '';
    public deleteComment: string = '';
    public deactivateDialog: boolean = false;
    public deactivateIds: string[] = [];
    public popUpRejectionReasons: RejectionReasonModel[] = [];
    public selectedRejectReason: RejectionReasonModel = {} as RejectionReasonModel;
    public isItOtherReasonPorp: boolean = false;
    public filterModel: any = {
        templateName: '',
        senderName: '',
        clientName: '',
        createdDate: '',
        providerName: '',
        displayId: '',
        status: [],
    };
    public reportModel: ReportModel = {
        requestId: '',
        displayId: '',
        senderName: '',
        tenantName: '',
        approveDateFrom: '',
        approveDateTo: '',
        createdDateFrom: '',
        createdDateTo: '',
        customerType: 0,
        senderType: 0,
        providerId: '',
        clientName: '',
        comment: '',
        representativeName: '',
        representativeMobile: '',
        representativeEmail: '',
        filterContractOption: 0,
        filterExpiryOption: 0,
        requestsFilterExpiryOption: 0,
        requestStatus: [],
        senderStatus: 0,
        numberOfActions: 0,
        paymentDate: '',
        expiryDate: '',
        pageIndex: '0',
        pageSize: '10',
    };
    public get isCstReadOnly(): boolean {
        return this.userRole === 3 || this.userRole === 4;
    }
    public get messageTemplatePaymentPhaseEnabled(): boolean {
        return !!(window.$config && window.$config.messageTemplatePaymentPhaseEnabled === true);
    }

      
    public user: UserModel = {
        userId: '',
        username: '',
        details: {
            Email: '',
            MobilePhone: '',
            Operator: '',
            Provider: '',
            OperatorId: '',
            ProviderId: '',
            TenantId: '',
            Role: '',
            ChangePasswordRequired: '',
        },
    };
    public autoInterval: any;
    public userRole: any;
    public scrollDiv: any;
    public nextPage: string = '';
    public scrollTop: number = 0;
    public selected: MessageTemplateRequestModel[] = [];
    public selectedIds: string[] = [];
    public ids: string[] = [];
    public senders: MessageTemplateRequestModel[] = [];
    public sendersCount: number = 0;
    public dashboardBoxes: MessageDashboardBoxesModel = {} as MessageDashboardBoxesModel;
    public User: any;
    public rejectResone: string = '';
    public rejectdialog: boolean = false;

    public pagination: any = { sortBy: 'createdDate', descending: true, page: 1, rowsPerPage: 10 };
    public tenantId: string = '';
    public headers: any = [
        { text: this.$t('dashboardPage.displayId'), sortable: true, value: 'displayId', align: 'center' },
        { text: this.$t('dashboardPage.templateName'), sortable: true, value: 'templateName', align: 'center' },
        { text: this.$t('dashboardPage.senderName'), sortable: true, value: 'senderName', align: 'center' },
        { text: this.$t('shared.classification'), sortable: false, value: 'classification', align: 'center' },
        { text: this.$t('shared.templateStatus'), sortable: false, value: 'templateStatus', align: 'center' }, 
        { text: this.$t('dashboardPage.clientName'), sortable: true, value: 'clientName', align: 'center' },
        { text: this.$t('dashboardPage.requestDate'), sortable: true, value: 'createdDate', align: 'center' },
        { text: this.$t('dashboardPage.expiryDate'), sortable: false, value: 'expiryDate', align: 'center' },
        { text: this.$t('shared.requestStatus'), sortable: false, value: 'requestStatus', align: 'center' }, 
        { text: this.$t('shared.actions'), sortable: false, align: 'center', width: '145' },
    ];
    public changeSort(column: any) {
        const header = this.headers.find((h: any) => h.value === column);
        if (!header || !header.sortable) return;
        if (this.pagination.sortBy === column) {
            this.pagination.descending = !this.pagination.descending;
        } else {
            this.pagination.sortBy = column;
            this.pagination.descending = false;
        }
        this.updatePaginate(this.pagination);
    }
    public checkColor(status: string): string {
        switch (status.toString()) {
            case '1':
                return '#c427ba';
            case '2':
                return '#8BC34A';
            case '3':
                return '#C42727';
            case '4':
                return '#aaa7a7';
            case '5':
                return '#014bb1';
            case '6':
                return '#F78500';
            case '7':
                return '#aaa7a7';
            case '8':
                return '#5aaa0b';
            case '11':
                return '#421984';
            default:
                return '#aaa7a7';
        }
    }
    public GetTemplateStatus(typeStatus: string): string {
        typeStatus = typeStatus.toString();
        switch (typeStatus) {
            case '1': return 'Pending Approval';
            case '2': return 'Approved';
            case '3': return 'Rejected';
            case '4': return 'Paid';
            case '5': return 'Expired';
            case '6': return 'Deleted';
            case '7': return 'Pending Payment';
            case '8': return 'Completed';
            case '11': return 'Deactivated';
            default: return '';
        }
    }

    public getActivation(operatorId: string, SenderId: string, ProviderId: string) {
        let isActive = false;
        const senderElem = this.senders.filter((s) => s.senderId === SenderId && s.providerId === ProviderId)[0];
        if (senderElem.requestStatus.toString() === '4') {
            if (senderElem.senderConectivityDetail.filter((a) => a.operator === operatorId)) {
                const arrayForthisOperator = senderElem.senderConectivityDetail
                    .filter((a) => a.operator === operatorId
                        && (a.status === 2 || a.status === 1)).length;
                const approvedArrayForthisOperatorApproved = senderElem.senderConectivityDetail
                    .filter((a) => a.operator === operatorId && a.status === 2).length;
                if (approvedArrayForthisOperatorApproved > 0) {
                    isActive = true;
                }
            }
        }
        return isActive;
    }

    public async mounted() {
        this.$emit('childinit', this.layoutSup);
        this.User = await this.userService.getUser();
        this.userRole = this.userRoleService.GetUserRole(this.User);

        const tasks: Promise<any>[] = [];
        if (this.userRole === 2 || this.userRole === 5) {
            tasks.push(this.isProviderLocked());
            tasks.push(this.isProviderExpired());
        }
        if (this.userRole === 1 || this.userRole === 9 || this.userRole === 15) {
            tasks.push(this.getRejectionReasons());
        }
        tasks.push(this.connectingRequestDashboardService.GetDashboardBoxes());

        const results = await Promise.all(tasks);
        this.dashboardBoxes = results[results.length - 1];

        this.tenantId = this.User.details.TenantId;
        this.search();
    }

    public async isProviderLocked() {
        const response = await this.connectingRequestDashboardService.isProviderLocked();
        this.providerLocked = response.result;
    }
    public async isProviderExpired() {
        const response = await this.connectingRequestDashboardService.isProviderExpired();
        this.providerExpired = response.result;
    }
    public async reset() {
        this.filterModel.templateName = '';
        this.filterModel.senderName = '';
        this.filterModel.clientName = '';
        this.filterModel.displayId = '';
        this.filterModel.providerName = '';
        this.filterModel.createdDate = '';
        this.filterModel.status = [];
        this.requestStatusBox = ['0'];
        this.search();
    }
    public async search() {
        if (!this.pagination.sortBy) {
            this.pagination.sortBy = 'createdDate';
            this.pagination.descending = true;
        }

        if (localStorage.storSettings) {
            const storSettings = JSON.parse(localStorage.storSettings);
            this.pagination = storSettings.pagination;
            this.filterModel.templateName = storSettings.filter.templateName;
            this.filterModel.senderName = storSettings.filter.senderName;
            this.filterModel.displayId = storSettings.filter.displayId;
            this.filterModel.clientName = storSettings.filter.clientName;
            this.filterModel.status = storSettings.filter.requestStatuses || [];
            this.requestStatusBox = this.filterModel.status.length
                ? this.filterModel.status.map((s: any) => s.toString())
                : ['0'];
        }

        localStorage.removeItem('storSettings');
        const response = await this.connectingRequestDashboardService.Get(this.buildSearchModel());
        if (response !== false && !response.isSuccess) {
            Toaster.error(response.errorMessage);
        }
        this.senders = response.result;
        this.sendersCount = response.totalCount;
    }
    public isEqual(value1: string | null, value2: string) {
        return (value1 === '' || value1 === null || value2.includes(value1));
    }

    public async filter(requestStatus: string, senderStatus: string) {
        this.senderStatus = '';

        if (requestStatus === '0') {
            this.requestStatusBox = ['0'];
        } else {
            this.requestStatusBox = this.requestStatusBox.filter(s => s !== '0');
            const index = this.requestStatusBox.indexOf(requestStatus);
            if (index === -1) {
                this.requestStatusBox.push(requestStatus);
            } else {
                this.requestStatusBox.splice(index, 1);
            }
            if (this.requestStatusBox.length === 0) {
                this.requestStatusBox = ['0'];
            }
        }

        if (this.requestStatusBox.includes('0')) {
            this.filterModel.status = [];
        } else {
            this.isFromFilterBox = true;
            this.filterModel.status = this.requestStatusBox.map(s => parseInt(s, 10));
        }

        this.pagination.page = 1;
        const response = await this.connectingRequestDashboardService.Get(this.buildSearchModel(0));
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }
        this.senders = response.result;
        this.sendersCount = response.totalCount;
        this.isFromFilterBox = false;
    }

    public selectAll() {
        if (this.selected.length) {
            this.selected = [];
            this.selectedIds = [];
        } else {
            this.selected = this.senders.slice();
            this.selectedIds = this.senders.map((x) => x.id);
        }
    }
    public select(event: any, id: string) {
        if (!event) {
            const index = this.selectedIds.indexOf(id);
            this.selectedIds.splice(index, 1);
        } else {
            this.selectedIds.push(id);
        }
    }
    public getRate(remainingDays: string, totalDays: string) {
        return (parseInt(remainingDays, 10) / parseInt(totalDays, 10)) * 100;
    }

    public showapproveDialog(id: string) {
        if (id !== '') {
            this.selectedIds.push(id);
        }
        const selectedSet = new Set(this.selectedIds);
        if (this.senders.some((s) => selectedSet.has(s.id) && s.automaticallyInserted)) {
            Toaster.error(this.$t('dashboardPage.someContractsAreMergeInserted').toString());
            return;
        }
        this.approveDialog = true;
    }
    public hideapproveDialog() {
        this.approveComment = '';
        this.approveDialog = false;
    }
    public showDeactivateDialog(id: string) {
        this.deactivateIds = [];
        if (id !== '') {
            this.deactivateIds.push(id);
        } else {
            this.deactivateIds = this.selectedIds;
            const deactivateSet = new Set(this.deactivateIds);
            if (this.senders.some((s) => deactivateSet.has(s.id) && s.requestStatus.toString() !== '8')) {
                Toaster.error(this.$t('dashboardPage.NotAllRequestsCanBeDeactivated').toString());
                return;
            }
        }
        this.deactivateDialog = true;
    }
    public hideDeactivateDialog() {
        this.deactivateDialog = false;
    }
    public async deactivate() {
        if (!this.deactivateIds.length) {
            return;
        }
        const response = await this.connectingRequestDashboardService.deactivateMessageTemplate(this.deactivateIds);
        if (!response || !response.isSuccess) {
            Toaster.error(response && response.errorMessage
                ? response.errorMessage
                : this.$t('shared.unexpectedError').toString());
            return;
        }
        this.deactivateIds = [];
        Toaster.success(this.$t('dashboardPage.RequestDeactivatedsuccessfully').toString());
        await this.reload();
        this.hideDeactivateDialog();
    }
    public async deleteRequest(id: string) {
        let ids: string[] = [];
        if (id !== '') {
            ids.push(id);
        } else {
            ids = this.Deleteids;
            const deleteSet = new Set(ids);
            if (this.senders.some((s) => deleteSet.has(s.id) && s.requestStatus.toString() !== '8' && s.requestStatus.toString() !== '11')) {
                Toaster.error(this.$t('dashboardPage.NotAllRequestsCanBeDeleted').toString());
                return;
            }
        }
        const response = await this.connectingRequestDashboardService.deleteMessageTemplate(ids);
        if (!response || !response.isSuccess) {
            Toaster.error(response && response.errorMessage
                ? response.errorMessage
                : this.$t('shared.unexpectedError').toString());
            return;
        }
        this.Deleteids = [];
        Toaster.success(this.$t('dashboardPage.RequestDeletedSuccessfully').toString());
        await this.reload();
        this.hideDeleteDialog();
    }
    public async approve(id: string) {
        let ids: string[] = [];
        if (id !== '') {
            ids.push(id);
        } else {
            ids = this.selectedIds;
            const idsSet = new Set(ids);
            if (this.senders.some((s) => idsSet.has(s.id) && s.requestStatus.toString() !== '1')) {
                Toaster.error(this.$t('dashboardPage.NotAllRequestsPendingApproval').toString());
                return;
            }
            if (this.userRole === 1 && this.senders.some((s) => idsSet.has(s.id) && s.tenantId !== this.tenantId)) {
                Toaster.error(this.$t('dashboardPage.NotAllSenderRequestRelatedToThisTenant').toString());
                return;
            }
        }
        const response = await this.connectingRequestDashboardService.approve(ids, this.approveComment);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
            await this.reload();
            this.selectedIds = [];
        } else {
            Toaster.success(this.$t('dashboardPage.RequestApprovedsuccessfully').toString());
            await this.reload();
            this.selectedIds = [];
        }
        this.hideapproveDialog();
    }

    public showDeleteDialog(id: string) {
        this.Deleteids = [];
        if (id !== '') {
            this.Deleteids.push(id);
        } else {
            this.Deleteids = this.selectedIds;
        }
        this.deleteDialog = true;
    }
    public hideDeleteDialog() {
        this.deleteDialog = false;
    }
    public isNumberFieldPaste(ev: any) {
        const paste = (ev.clipboardData).getData('text');
        if (isNaN(paste)) {
            ev.preventDefault();
        }
    }
    public isNumberField(val: KeyboardEvent) {
        if (!this.validationService.isNumber(val.key)) {
            val.preventDefault();
        }
    }
    public showresendDialog(id: string) {
        if (id !== '') {
            if (!this.selectedIds.includes(id)) {
                this.selectedIds.push(id);
            }
        } else {
            this.resendids = this.selectedIds;
            const resendSet = new Set(this.resendids);
            if (this.senders.some((s) => resendSet.has(s.id) && s.requestStatus.toString() !== '3')) {
                Toaster.error(this.$t('dashboardPage.NotAllTemplateRejected').toString());
                return;
            }
        }
        const selectedSet = new Set(this.selectedIds);
        if (this.senders.some((s) => selectedSet.has(s.id) && s.automaticallyInserted)) {
            Toaster.error(this.$t('dashboardPage.someContractsAreMergeInserted').toString());
            return;
        }
        this.resendDialog = true;
    }
    public hideresendDialog() {
        this.resendComment = '';
        this.resendDialog = false;
    }
    public async resend(id: string) {
        let ids: string[] = [];
        if (id !== '') {
            ids.push(id);
        } else {
            ids = this.selectedIds.length ? this.selectedIds : this.resendids;
            const resendIdsSet = new Set(ids);
            if (this.senders.some((s) => resendIdsSet.has(s.id) && s.automaticallyInserted)) {
                Toaster.error(this.$t('dashboardPage.someContractsAreMergeInserted').toString());
                return;
            }
            if (this.senders.some((s) => resendIdsSet.has(s.id) && s.requestStatus.toString() !== '3')) {
                Toaster.error(this.$t('dashboardPage.NotAllTemplateRejected').toString());
                return;
            }
        }
        const response = await this.connectingRequestDashboardService.resend(ids, this.resendComment);
        if (!response || !response.isSuccess) {
            Toaster.error(response && response.errorMessage
                ? response.errorMessage
                : this.$t('shared.unexpectedError').toString());
        } else {
            this.selectedIds = [];
            this.resendids = [];
            Toaster.success(this.$t('dashboardPage.resentSuccessfully').toString());
            await this.reload();
        }
        this.hideresendDialog();
    }
    public async exportToExcel() {
        const model = {
            senderName: this.filterModel.senderName || '',
            displayId: this.filterModel.displayId || '',
            clientName: this.filterModel.clientName || '',
            providerName: this.filterModel.providerName || '',
            templateName: this.filterModel.templateName || '',
            requestStatuses: this.formatRequestStatuses(),
            messageTemplateStatus: this.senderStatus !== '' ? parseInt(this.senderStatus, 0) : 0,
            sortDirection: this.pagination.descending,
            sortBy: this.pagination.sortBy || 'createdDate',
        };
        const response = await this.connectingRequestDashboardService.ExportTemplateRequestsToExcel(model);
        if (response === false || !response.isSuccess) {
            this.loaderService.HideLoader();
            Toaster.error(response ? response.errorMessage : this.$t('shared.unexpectedError').toString());
        }
    }

    public async showRejectDialog(id: string) {
        this.ids = [];
        if (id !== '') {
            this.ids.push(id);
        } else {
            this.ids = this.selectedIds;
            const idsSet = new Set(this.ids);
            if (this.senders.some((s) => idsSet.has(s.id) && s.requestStatus.toString() !== '1')) {
                Toaster.error(this.$t('dashboardPage.NotAllRequestsPendingApproval').toString());
                return;
            }
            if (this.senders.some((s) => idsSet.has(s.id) && s.automaticallyInserted)) {
                Toaster.error(this.$t('dashboardPage.someContractsAreMergeInserted').toString());
                return;
            }
        }
        this.rejectdialog = true;
    }
    public async hideRejectDialog() {
        this.rejectResone = '';
        this.selectedRejectReason = {} as RejectionReasonModel;
        this.isItOtherReasonPorp = false;
        this.rejectdialog = false;
    }
    public async reject() {
        if (this.rejectResone === '') {
            return;
        }
        const rejectSet = new Set(this.ids);
        if (this.userRole === 1 && this.senders.some((s) => rejectSet.has(s.id) && s.tenantId !== this.tenantId)) {
            Toaster.error(this.$t('dashboardPage.NotAllSenderRequestRelatedToThisTenant').toString());
            return;
        }
        this.rejectdialog = false;
        const response = await this.connectingRequestDashboardService.reject(this.ids, this.rejectResone);
        if (!response || !response.isSuccess) {
            Toaster.error(response && response.errorMessage
                ? response.errorMessage
                : this.$t('shared.unexpectedError').toString());
            this.rejectdialog = true;
            return;
        }
        this.rejectResone = '';
        this.selectedRejectReason = {} as RejectionReasonModel;
        this.isItOtherReasonPorp = false;
        this.selectedIds = [];
        this.ids = [];
        Toaster.success(this.$t('dashboardPage.RequestRejectedsuccessfully').toString());
        await this.reload();
    }
    public PreparePay(id: string) {
        let ids: string[] = [];
        if (id !== '') {
            ids.push(id);
        } else {
            ids = this.selectedIds;
            const paySet = new Set(ids);
            if (this.senders.some((s) => paySet.has(s.id) && s.requestStatus.toString() !== '7')) {
                Toaster.error(this.$t('dashboardPage.NotAllSenderPendingPay').toString());
                return;
            }
        }
        const storSettings = {
            pagination: this.pagination,
            filter: {
                senderName: this.filterModel.senderName,
                displayId: this.filterModel.displayId,
                clientName: this.filterModel.clientName,
                providerName: this.filterModel.providerName,
                createdDate: this.filterModel.createdDate,
                requestStatuses: this.filterModel.status,
                senderStatus: this.senderStatus !== '' ? parseInt(this.senderStatus, 0) : 0,
                pageIndex: (this.pagination.page - 1).toString(),
                pagesize: this.pagination.rowsPerPage,
                sortDirection: this.pagination.descending,
                sortBy: this.pagination.sortBy,
            },
        };
        localStorage.storSettings = JSON.stringify(storSettings);
        localStorage.setItem('paymentSource', 'messageTemplate');
        this.$router.push({ name: 'Payment', params: { ids: ids.join(',') }, query: { fromMessageTemplate: '1' } });
    }
    public Details(id: string) {
        const storSettings = {
            pagination: this.pagination,
            filter: {
                senderName: this.filterModel.senderName,
                displayId: this.filterModel.displayId,
                clientName: this.filterModel.clientName,
                providerName: this.filterModel.providerName,
                createdDate: this.filterModel.createdDate,
                requestStatuses: this.filterModel.status,
                senderStatus: this.senderStatus !== '' ? parseInt(this.senderStatus, 0) : 0,
                pageIndex: (this.pagination.page - 1).toString(),
                pagesize: this.pagination.rowsPerPage,
                sortDirection: this.pagination.descending,
                sortBy: this.pagination.sortBy,
            },
        };
        localStorage.storSettings = JSON.stringify(storSettings);
        this.$router.push({ name: 'MessageTemplateRequestInfo', params: { id } });
    }
    public ChangeSenderType(id: string) {
        const storSettings = {
            pagination: this.pagination,
            filter: {
                senderName: this.filterModel.senderName,
                displayId: this.filterModel.displayId,
                clientName: this.filterModel.clientName,
                providerName: this.filterModel.providerName,
                createdDate: this.filterModel.createdDate,
                requestStatuses: this.filterModel.status,
                senderStatus: this.senderStatus !== '' ? parseInt(this.senderStatus, 0) : 0,
                pageIndex: (this.pagination.page - 1).toString(),
                pagesize: this.pagination.rowsPerPage,
                sortDirection: this.pagination.descending,
                sortBy: this.pagination.sortBy,
            },
        };
        localStorage.storSettings = JSON.stringify(storSettings);
        this.$router.push({ name: 'ChangeSenderType', params: { id } });
    }
    public UpdateRequestData(id: string) {
        const storSettings = {
            pagination: this.pagination,
            filter: {
                senderName: this.filterModel.senderName,
                displayId: this.filterModel.displayId,
                clientName: this.filterModel.clientName,
                providerName: this.filterModel.providerName,
                createdDate: this.filterModel.createdDate,
                requestStatuses: this.filterModel.status,
                senderStatus: this.senderStatus !== '' ? parseInt(this.senderStatus, 0) : 0,
                pageIndex: (this.pagination.page - 1).toString(),
                pagesize: this.pagination.rowsPerPage,
                sortDirection: this.pagination.descending,
                sortBy: this.pagination.sortBy,
            },
        };
        localStorage.storSettings = JSON.stringify(storSettings);
        this.$router.push({ name: 'UpdateContractRequest', params: { id } });
    }
    public ConectivityDetail(senderId: string) {
        this.$router.push({ name: 'ContractConnectivityDetail', params: { senderId } });
    }
    public async updatePaginate(val: any) {
        const response = await this.connectingRequestDashboardService.Get(
            this.buildSearchModel(val.page - 1, val.rowsPerPage),
        );
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }
        this.senders = response.result;
        this.sendersCount = response.totalCount;
        this.pagination.page = val.page;
        this.pagination.rowsPerPage = val.rowsPerPage;
    }
    public HasConectivityDetail(SenderId: string): boolean {
        const senderElem = this.senders.filter((s) => s.senderId === SenderId)[0];
        if (senderElem.senderConectivityDetail.filter((a) => a.status !== 4).length > 0) {
            return false;
        } else {
            return true;
        }
    }
    public get isAnySelected(): boolean {
        return this.selectedIds.length > 0;
    }
    public async reload() {
        const [dashboardResponse, boxesResponse] = await Promise.all([
            this.connectingRequestDashboardService.Get(this.buildSearchModel()),
            this.connectingRequestDashboardService.GetDashboardBoxes(),
        ]);
        this.dashboardBoxes = boxesResponse;
        if (!dashboardResponse || !dashboardResponse.isSuccess) {
            Toaster.error(dashboardResponse ? dashboardResponse.errorMessage : this.$t('shared.unexpectedError').toString());
        }
        this.senders = dashboardResponse.result;
        this.sendersCount = dashboardResponse.totalCount;
        this.selectedIds = [];
        this.selected = [];
    }
    public get rejectReasonIsValid(): boolean {
        return this.rejectResone !== '';
    }

    public async getRejectionReasons() {
        const response = await this.connectingRequestDashboardService.getSenderNameRejectReasons(3);
        if (!response || !response.result) {
            this.popUpRejectionReasons = [];
        } else {
            this.popUpRejectionReasons = response.result;
        }
        this.popUpRejectionReasons.push({ id: '0', rejectionText: 'other', requestType: 3 });
    }
    public handleItemChange() {
        if (this.selectedRejectReason.id == '0') {
            this.isItOtherReasonPorp = true;
            this.rejectResone = '';
        }
        else {
            this.isItOtherReasonPorp = false;
            this.rejectResone = this.selectedRejectReason.rejectionText
        }
    }
    public get isItOtherReason(): boolean {
        return this.isItOtherReasonPorp;
    }

    private searchTimeout: any = null;

    public onInputSearch() {
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
        this.searchTimeout = setTimeout(() => {
            this.search();
        }, 1000);
    }

    private formatRequestStatuses(): string {
        return this.filterModel.status && this.filterModel.status.length > 0
            ? this.filterModel.status.join(',')
            : '';
    }

    private buildSearchModel(pageIndex?: number, pageSize?: number) {
        return {
            templateName: this.filterModel.templateName || '',
            senderName: this.filterModel.senderName || '',
            displayId: this.filterModel.displayId || '',
            clientName: this.filterModel.clientName || '',
            providerName: this.filterModel.providerName || '',
            createdDate: this.filterModel.createdDate || '',
            requestStatuses: this.formatRequestStatuses(),
            senderStatus: this.senderStatus !== '' ? parseInt(this.senderStatus, 10) : 0,
            sortDirection: this.pagination.descending,
            sortBy: this.pagination.sortBy,
            pageIndex: pageIndex !== undefined ? pageIndex : ((this.pagination.page || 1) - 1),
            pagesize: pageSize !== undefined ? pageSize : (this.pagination.rowsPerPage || 10),
        };
    }
}
